import { MerchantPaymentProduct, Offer } from '@ads-bread/shared/bread/codecs';

/**
 * Gets valid offers and warns to console if there are any invalid offers.
 *
 * @param offers - An array of offers.
 * @param merchantPaymentProducts - The merchant payment products.
 *
 * @returns - Returns an offer array
 *
 */
export function validateOfferProductTypes(
  offers: Offer[],
  merchantPaymentProducts: MerchantPaymentProduct[]
): Offer[] {
  const groupedOffers = groupValidAndInvalidOffers(
    offers,
    merchantPaymentProducts
  );
  if (groupedOffers.invalidOffers.length > 0) {
    const nonMatchingOffers = groupedOffers.invalidOffers.map(
      (offer) => offer.paymentProduct.id
    );
    const availableProducts = merchantPaymentProducts?.map(
      (product) => product.paymentProduct.id
    );

    console.warn(
      `Could not find matching product types for all buyer offers.
        Available merchant payment products ${availableProducts}
        Buyer offers with payment products that do not match ${nonMatchingOffers}`
    );
  }
  return groupedOffers.validOffers;
}

/**
 * Checks if all offers are valid.
 *
 * @param offers - An array of offers.
 * @param merchantPaymentProducts - The merchant payment products.
 *
 * @returns - Returns true if all offers are valid
 *
 */
export function hasValidOffers(
  offers: Offer[],
  merchantPaymentProducts: MerchantPaymentProduct[]
): boolean {
  return (
    groupValidAndInvalidOffers(offers, merchantPaymentProducts).invalidOffers
      .length === 0
  );
}

function groupValidAndInvalidOffers(
  offers: Offer[],
  merchantPaymentProducts: MerchantPaymentProduct[]
) {
  const groupedOffers: {
    /** represents reconciled offers */
    validOffers: Offer[];
    /** represents invalid offers */
    invalidOffers: Offer[];
  } = { validOffers: [], invalidOffers: [] };

  return offers.reduce((acc, curr) => {
    const matchingPaymentProductType = merchantPaymentProducts.find(
      (product) => product.paymentProduct.id === curr.paymentProduct.id
    )?.paymentProduct.type;

    if (matchingPaymentProductType) {
      acc.validOffers.push(curr);
    } else {
      acc.invalidOffers.push(curr);
    }
    return acc;
  }, groupedOffers);
}
